import { render, staticRenderFns } from "./MaintenanceView.vue?vue&type=template&id=18fa41e3&scoped=true"
var script = {}
import style0 from "./MaintenanceView.vue?vue&type=style&index=0&id=18fa41e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fa41e3",
  null
  
)

export default component.exports